'use client'

import { PRIVACY_PAGE } from '@constants/routes'

const HOST = process.env.NEXT_PUBLIC_HOST
export const COOKIE_DECLARATION_ID = 'pliki-cookie'

// Otwiera okno zgód Cookiebota; bez Cookiebota prowadzi do deklaracji cookies w polityce prywatności.
export default function CookieSettingsButton ({ className, children }) {
    const onClick = () => {
        if (typeof window.Cookiebot?.renew === 'function') window.Cookiebot.renew()
        else window.location.href = `${HOST}${PRIVACY_PAGE}#${COOKIE_DECLARATION_ID}`
    }

    return <button className={className} onClick={onClick} type="button">{children}</button>
}
